import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../components/Header';
import api from '../api';
import { formatarData, estaAtrasado } from '../utils/datas';

const STATUS = {
  aberto: { l: 'Aberta', c: 'alerta' },
  em_andamento: { l: 'Em andamento', c: 'neutro' },
  concluido: { l: 'Concluída', c: 'ok' },
  cancelado: { l: 'Cancelada', c: 'neutro' },
};
const fmt = (d) => formatarData(d);

export default function MinhasTarefas() {
  const [tarefas, setTarefas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [verConcluidas, setVerConcluidas] = useState(false);

  function carregar() {
    return api.get('/atas/minhas-tarefas')
      .then(({ data }) => setTarefas(data.tarefas))
      .catch(err => Swal.fire('Erro', err.response?.data?.error || 'Não foi possível carregar suas tarefas.', 'error'))
      .finally(() => setCarregando(false));
  }
  useEffect(() => { carregar(); }, []);

  async function mudarStatus(t, status) {
    let observacao;
    if (status === 'concluido') {
      const r = await Swal.fire({
        icon: 'question', title: 'Marcar como feita?', text: t.descricao,
        input: 'textarea', inputPlaceholder: 'Quer deixar alguma observação? (opcional)',
        showCancelButton: true, confirmButtonText: 'Sim, está feita', cancelButtonText: 'Cancelar',
      });
      if (!r.isConfirmed) return;
      observacao = r.value || null;
    }
    try {
      await api.put(`/atas/pendencias/${t.id}/status`, { status, ...(observacao !== undefined ? { observacao } : {}) });
      carregar();
    } catch (err) {
      Swal.fire('Ops', err.response?.data?.error || 'Não foi possível atualizar.', 'error');
    }
  }

  const abertas = tarefas.filter(t => t.status === 'aberto' || t.status === 'em_andamento');
  const fechadas = tarefas.filter(t => !(t.status === 'aberto' || t.status === 'em_andamento'));
  const lista = verConcluidas ? fechadas : abertas;

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 900 }}>
        <div className="adm-topo">
          <div>
            <h1>Minhas tarefas</h1>
            <p>O que ficou combinado pra você nas reuniões. Marque como feita quando resolver.</p>
          </div>
        </div>

        <div className="adm-filtros">
          <button className={`doc-chip${!verConcluidas ? ' doc-chip--ativo' : ''}`} onClick={() => setVerConcluidas(false)}>
            Em aberto <span className="doc-chip-qtd">{abertas.length}</span>
          </button>
          <button className={`doc-chip${verConcluidas ? ' doc-chip--ativo' : ''}`} onClick={() => setVerConcluidas(true)}>
            Concluídas <span className="doc-chip-qtd">{fechadas.length}</span>
          </button>
        </div>

        {carregando && <div>Carregando…</div>}

        {!carregando && lista.length === 0 && (
          <div className="conteudo-card adm-vazio">
            <i className="bi bi-check2-circle" style={{ fontSize: '2.2rem' }}></i>
            <p style={{ marginTop: 10 }}>{verConcluidas ? 'Nada concluído ainda.' : 'Nenhuma tarefa em aberto. Tudo em dia!'}</p>
          </div>
        )}

        <div className="acesso-lista">
          {lista.map(t => {
            const st = STATUS[t.status] || STATUS.aberto;
            const aberta = t.status === 'aberto' || t.status === 'em_andamento';
            const atrasada = aberta && estaAtrasado(t.prazo);
            return (
              <div className="acesso-row" key={t.id} style={atrasada ? { borderLeft: '4px solid #C62828' } : undefined}>
                <div className="acesso-info" style={{ minWidth: 0 }}>
                  <div className="acesso-info-txt" style={{ minWidth: 0 }}>
                    <div className="acesso-nome">{t.descricao}</div>
                    <div className="acesso-sub">
                      <span className={`adm-badge adm-badge--${st.c}`}>{st.l}</span>
                      {t.prazo && ` · prazo ${fmt(t.prazo)}`}
                      {atrasada && <span style={{ color: '#C62828', fontWeight: 700 }}> · atrasada</span>}
                      {' · '}<Link className="adm-link" to={`/atas/${t.ata_id}`}>{t.ata_titulo}</Link>
                    </div>
                  </div>
                </div>
                {aberta && (
                  <div className="acesso-acoes">
                    {t.status === 'aberto' && (
                      <button className="btn btn-outline-secondary btn-sm" onClick={() => mudarStatus(t, 'em_andamento')}>Comecei</button>
                    )}
                    <button className="btn-centrao" onClick={() => mudarStatus(t, 'concluido')}>
                      <i className="bi bi-check2 me-1"></i> Feita
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </main>
    </>
  );
}
